import { NodeApi, type NodeIn, type TElement, type Value } from 'platejs';

import { ElementApi } from '@@plate/api/ElementApi';

const removeSoftHyphensAndNewLines = (node: TElement) =>
    NodeApi.string(node)
        .replace(/\u00AD/g, '')
        .replace(/\n/g, '');

export const getCharacterCount = (nodes: unknown) => {
    if (typeof nodes === 'string') {
        return nodes.length;
    }

    if (ElementApi.isElementList(nodes)) {
        const counter = nodes.reduce((acc, node) => {
            if (
                ElementApi.isTextBlockElementType(node) ||
                ElementApi.isInterviewSegmentElementType(node)
            ) {
                // We do not want the soft-hyphens to be counted as character
                const text = removeSoftHyphensAndNewLines(node);

                return acc + text.length;
            }

            return acc;
        }, 0);

        return counter;
    }

    return 0;
};

export const getElementCount = (node: TElement) => {
    if (ElementApi.isInfoboxElement(node)) {
        return (
            NodeApi.string(node.children[0]).length + getCharacterCount(node.children[1].children)
        );
    }

    return removeSoftHyphensAndNewLines(node).length;
};

export const shouldCountCharsForElement = (node: NodeIn<Value>) =>
    ElementApi.isTextBlockElementType(node) ||
    ElementApi.isInterviewSegmentElementType(node) ||
    ElementApi.isInfoboxElementType(node) ||
    ElementApi.isDynamicTeaserTitleElementType(node) ||
    ElementApi.isQuoteCaptionElementType(node) ||
    ElementApi.isQuoteTextElementType(node);
